import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { setStorage } from 'utilz';
import { URLS } from 'config';

import Modal from 'components/Modal';
import PageTitle from 'components/PageTitle';

import './styles.scss';

class Success extends React.Component {
  componentWillMount() {
    this.disagreeHandl();
    this.props.getList(this.redirect);
  }
    redirect = () => {
      setTimeout(() => {
        this.props.history.push(URLS.DOWNPAYMENTS);
      }, 3000);
    }
    disagreeHandl = () => {
      this.props.confirmationChangeHandl(true);

      this.props.confirmationSend(() => {
        this.props.workingChangeHandl(true);
        setStorage({
          working: {
            working: true
          }
        });
        setStorage({
          confirmation: {
            confirmation: true
          }
        });
      });
    }
    isOpen = true;

    render() {
      return (
        <Modal isOpen={this.isOpen}>
          <div className="success-modal">
            <div className="modal-wrapper">
              <PageTitle>
                    We will inform you when documents will be reviewed
              </PageTitle>
              <ul className="files">
                {
                  this.props.uploaded.map((element) => {
                      const index = this.props.types.findIndex(type => type.type === element.type);
                      if (index === -1) return null;
                      return (
                        // eslint-disable-next-line
                        <li className="file" key={element['_id']}>
                          <i className="ion-document-text" />
                          { this.props.types[index].text }
                        </li>
                    );
                  })
              }
              </ul>
            </div>
          </div>
        </Modal>
      );
    }
}

Success.propTypes = {
  types: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired
  })).isRequired,
  confirmationChangeHandl: PropTypes.func.isRequired,
  confirmationSend: PropTypes.func.isRequired,
  workingChangeHandl: PropTypes.func.isRequired,
  // eslint-disable-next-line
  uploaded: PropTypes.array.isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired,
  getList: PropTypes.func.isRequired
};

export default withRouter(Success);



// WEBPACK FOOTER //
// ./src/pages/Upload/Success/index.js